import { render, staticRenderFns } from "./LettersList.vue?vue&type=template&id=5bb9718a&scoped=true&"
import script from "./LettersList.vue?vue&type=script&lang=ts&"
export * from "./LettersList.vue?vue&type=script&lang=ts&"
import style0 from "./LettersList.vue?vue&type=style&index=0&id=5bb9718a&lang=scss&scoped=true&"
import style1 from "./LettersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb9718a",
  null
  
)

export default component.exports